export default __webpack_public_path__ + "static/media/task-files-icon.0379dc45.svg";